import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-modal',
  imports: [MatDialogModule, CommonModule, TranslocoModule],
  templateUrl: './confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {

  locale = 'sv';

  constructor(public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: {
      text: any,
      org: any,
      infoOnly?: boolean,
      translationKey?: string,
      titleKey?: string
    },
    private translocoService: TranslocoService
  ) {
    this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });
  }
}